import { CreateMultiDayWorkFormValues } from '../schemas/create-multi-day-work-form.schema.types';
import { WorkFormContext } from '../../work-form.types';

export const pickMultiDayWorkFormValidationValues = (
  values: Pick<WorkFormContext, keyof CreateMultiDayWorkFormValues>
) => ({
  jobId: values.jobId,
  department: values.department,
  isFreelance: values.isFreelance,
  isTempwork: values.isTempwork,
  isEmployee: values.isEmployee,
  multiDayDates: values.multiDayDates,
  multiDayDayBlocks: values.multiDayDayBlocks,
});
